// 表单配置字段——岗位信息
export default () => {
    return [
      {
        name: "id",
        formItem: {
          type: "hidden"
        }
      },
      {
        title: "账号",
        name: "name",
        dataIndex: "name",
        formItem: {},
        tableItem:{}
      },
      {
        title: "密码",
        name: "password",
        dataIndex: "password",
        formItem: {},
        tableItem:{}
      }
    ]
  }